// =============================================================================
// FILE STATUS HEADER  (lihat /app/memory/MASTER_BLUEPRINT.md A7)
// status   : ACTIVE
// version  : 1.0
// updated  : 2026-06-15
// replaces : -
// protected: NO  -> Tambahkan riwayat di /app/memory CHANGELOG saat diubah.
// =============================================================================

import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
